import React from "react";
import { Loading, useGetIdentity } from "react-admin";
import { Dashboard as DebateDashboard } from "./debate";
import { Dashboard as ParliamentDashboard } from "./parliament";
import { Dashboard as SocialNetworksDashboard } from "./social_networks";

export const Dashboard = () => {
	const { identity } = useGetIdentity();

	const getDashboard = () => {
		const modules = identity?.settings?.modules || {};
		if (modules.debateSpace !== false) return <DebateDashboard />;
		if (modules.socialModeration === true) return <SocialNetworksDashboard />;
		if (modules.parliament === true) return <ParliamentDashboard />;
		return <Loading />;
	};

	if (!identity) {
		return <Loading />;
	}

	return getDashboard();
};
